import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { IconButton, Fab } from '@material-ui/core';
import { Chat, Close } from '@material-ui/icons';

export default function ChatIA() {
  const { token } = useSelector(state => state.login);
  const { userId } = useSelector(state => state.profile);

  const [isChatOpen, setIsChatOpen] = useState(false);

  return(
    <>
      {!isChatOpen && (
        <Fab
          color="primary"
          onClick={() => setIsChatOpen(true)}
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 1100
          }}
        >
          <Chat />
        </Fab>
      )}
      {isChatOpen && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            width: 480,
            height: 550,
            backgroundColor: "#FFFFFF",
            borderRadius: 10,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: 1200
          }}
        >
          <div
            style={{
              backgroundColor: "#1976d2",
              color: "#FFFFFF",
              padding: "8px 12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <span>Atendimento</span>
            <IconButton
              size="small"
              onClick={() => setIsChatOpen(false)}
              style={{ color: "#FFFFFF" }}
            >
              <Close />
            </IconButton>
          </div>
          <iframe
            src={`https://dev-jump-chat.netlify.app?user_id=${userId}&token=${token}`}
            title="Chat Atendimento"
            style={{
              flex: 1,
              border: "none",
              width: "100%"
            }}
          />
        </div>
      )}
    </>
  );
}